// extracted by mini-css-extract-plugin
export default {"controls":"FlowchartControls_controls__mcwZU"};